export enum CoaTemplateApplySource {
    WIZARD = "wizard",
    ADD_CLIENT = "add_client",
    ENTITY_CREATE = "entity_create",
}
